import regionReducer from './reducer';

export default regionReducer;

export {
  FETCH_REGION_REQUEST,
  FETCH_REGION_SUCCESS,
  FETCH_REGION_FAILURE,
  fetchRegionRequest,
  fetchRegionSuccess,
  fetchRegionFailure
} from './actions';

export { getRegion } from './selectors';



// WEBPACK FOOTER //
// ./src/store/region/index.js